export default {
  birthdayMonthErrors () {
    const errors = []
    if (!this.$v.birthdayMonth.$dirty) return errors
    !this.$v.birthdayMonth.required && errors.push('Selecione o mês dos aniversariantes.')
    return errors
  }
}
